import React from 'react'
import Footer from '../images/Footer.png'

const FooterPage = () => {
  return (
    <div>
      <h1 className="logo"><img src ={Footer} /></h1>
    </div>
  )
}

export default FooterPage